/*
 * @Author: ts.r
 * @Date: 2020-10-26 11:45:27
 * @LastEditTime: 2021-02-24 11:35:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /cmine-pro-fe/src/components/common/topMenu.ts
 */
const DOMAIN = process.env.VUE_APP_PUBLIC_MAIN_URL || 'http://www.test.17zuoye.net/'
const PATH = DOMAIN + 'teacher/teachingresource/index.vpage'
const menu = [
  {
    path: '/',
    name: 'paper',
    meta: {
      name: '试卷',
      allowSubjects: 'all',
      new: false,
      useType: 'all'
    }
  },
  {
    path: '/question',
    name: 'question',
    meta: {
      name: '手工组卷',
      allowSubjects: 'all',
      new: false,
      useType: 'all'
    }
  },
  // {
  //   path: '/auto',
  //   name: 'auto',
  //   meta: {
  //     name: '智能组卷',
  //     allowSubjects: 'all',
  //     new: false,
  //     useType: 'all'
  //   }
  // },
  {
    path: '/mistake',
    name: 'mistake',
    meta: {
      name: '错题组卷',
      new: false,
      allowSubjects: [101, 102, 103, 203],
      useType: 'all'
    }
  },
  {
    path: '/assessment/lib',
    name: 'assessment',
    meta: {
      new: false,
      name: '在线测评',
      allowSubjects: [101, 102, 103, 203],
      useType: [1, 10]
    }
  },
  {
    path: '/courseware',
    name: 'courseware',
    meta: {
      new: false,
      name: '课件·微课·绘本',
      allowSubjects: [101, 102, 103, 201, 202, 203, 204, 205, 302, 304, 305]
    }
  },
  {
    path: '/junior/real',
    name: 'junior',
    meta: {
      name: '中考',
      allowSubjects: [201, 202, 203, 204, 205, 206, 207, 208, 209],
      new: false,
      useType: 'all'
    }
  },
  {
    path: '/senior/real',
    name: 'senior',
    meta: {
      name: '高考',
      allowSubjects: [301, 302, 303, 304, 305, 306, 307, 308, 309],
      new: false,
      useType: 'all'
    }
  },
  {
    path: '/paperAnalysis',
    name: 'paperAnalysis',
    meta: {
      new: true,
      name: '试卷分析',
      allowSubjects: [202, 203],
    }
  },
  {
    path: PATH,
    name: 'checkSource',
    meta: {
      name: '查看备课资源',
      allowSubjects: [101, 102],
      new: false,
      useType: 'all'
    }
  }
]
// 获取学科、学段
const subject_choices = [
  {
    label: '小学',
    subs: [
      {
        label: '小学语文',
        value: 101
      },
      {
        label: '小学数学',
        value: 102
      },
      {
        label: '小学英语',
        value: 103
      }
    ]
  },
  {
    label: '初中',
    subs: [
      {
        label: '初中语文',
        value: 201
      },
      {
        label: '初中数学',
        value: 202
      },
      {
        label: '初中英语',
        value: 203
      },
      {
        label: '初中物理',
        value: 204
      },
      {
        label: '初中化学',
        value: 205
      },
      {
        label: '初中生物',
        value: 206
      },
      {
        label: '初中政治',
        value: 207
      },
      {
        label: '初中地理',
        value: 208
      },
      {
        label: '初中历史',
        value: 209
      }
    ]
  },
  {
    label: '高中',
    subs: [
      {
        label: '高中语文',
        value: 301
      },
      {
        label: '高中数学',
        value: 302
      },
      {
        label: '高中英语',
        value: 303
      },
      {
        label: '高中物理',
        value: 304
      },
      {
        label: '高中化学',
        value: 305
      },
      {
        label: '高中生物',
        value: 306
      },
      {
        label: '高中政治',
        value: 307
      },
      {
        label: '高中地理',
        value: 308
      },
      {
        label: '高中历史',
        value: 309
      }
    ]
  }
]

const assessment_subjects = [
  {
    label: '小学',
    subs: [
      {
        label: '小学语文',
        value: 101
      },
      {
        label: '小学数学',
        value: 102
      },
      {
        label: '小学英语',
        value: 103
      }
    ]
  },
  {
    label: '初中',
    subs: [
      {
        label: '初中英语',
        value: 203
      }
    ]
  }
]

const BLOCK_REGIONS = [
  '513431'
]

export { menu, subject_choices, assessment_subjects, BLOCK_REGIONS }
